import { ApiStatus } from 'common/enums';

import { Mode } from 'modules/data-editor/enums/mode.enum';
import { MasterDataState } from '../models/master-data.model';

const initialMasterDataState: MasterDataState = {
    uploadStatus: {},
    selectedFiles: [],
    uploadingFiles: [],
    isUploadModalVisible: false,
    masterData: {},
    isPreviewProgressVisible: false,
    mode: Mode.DataLoaded,
    fieldErrors: [],
    previewDetailsAPIStatus: ApiStatus.NONE,
    previewDetails: undefined,
    editStatus: {},
    updatedData: {},
    isEditModalVisible: false,
    deleteData: {},
    searchList: {},
    addedData: {},
    isAddModalVisible: false,
    saveToMaster: {},
    messageBanner: {
        isVisible: false,
        message: ''
    },
    hierarchicalData: {},
    entityDetails: {},
    archiveStatus: {},
    selectedVariantsArray: [],
    addSubCategory: {},
    editSubCategory: {},
    reviewStatus: {},
    moveSubCategory: {},
    linkIndicator: {},
    moveIndicator: {},
    gridScrollToTop: false,
    deleteFeasibility: {},
    archiveFeasibility: {},
    childSubCategoryData: {},
    isMovableSubCategory: {},
    discardChanges: {},
    copyIndicator: {},
    cloneFeasibility: {},
    isDuplicateIndicator: {}
};

export default initialMasterDataState;
